import { Action } from '../classes/Action';

export function createAction(type: string, payload?: any) {
  const action = new Action(payload);
  action.type = type;
  return action;
}
